module.exports = __webpack_public_path__ + "img/05univl.17446ce3.png";